export default __webpack_public_path__ + "static/photo-bar-6-8bfafe6d73184af1c25de6ba50a81cac.jpg";